<template>
  <section :id="$options.name" class="policies">
    <h2 class="policies__title">Leggi prima di prenotare</h2>
    <div class="policies__wrap" v-if="details.policies">
      <policy-item
        v-for="(policy, policy_index) in policies"
        :key="_uid+policy_index"
        :icon="policy.icon"
        :title="policy.name"
        :detail="get_policy_content(policy.content, policy.key)"
      />
    </div>
  </section>
</template>

<script>
import moment from 'moment'
import { get_policies } from "@bookingv3/resources"
import PolicyItem from '@bookingv3/components/blocks/detail/policy-item'

export default {
  inheritAttrs: false,
  name: 'policies',

  components: {
    'policy-item': PolicyItem,
  },

  props: {
    details: Object,
  },

  data() {
    return {
    }
  },

  computed: {

    // Crea la struttura dati
    policies() {
      const {policies, checkin_checkout_times} = this.details

      const check_times = ['checkin', 'checkout'].map((key) => {
        const format_time = time => time ? moment(time, "HH:mm:ss").format("HH:mm") : '',
              from = format_time(checkin_checkout_times[`${key}_from`]),
              to = format_time(checkin_checkout_times[`${key}_to`])
        return {
          key,
          name: key === 'checkin' ? 'Arrivo' : 'Partenza',
          icon: key === 'checkin' ? 'login' : 'logout',
          content:
            from && to ? `dalle ${from} alle ${to}`
            : from ? `dalle ${from}`
            : to ? `fino alle ${to}`
            : 'Orari non disponibili'
        }
      })

      const parse_policies = Object.entries(policies).map(([key, value]) => ({
        key,
        name: this.get_policies(key).name,
        icon: this.get_policies(key).icon,
        content: value,
      })).filter((policy) => policy.content)

      return [...check_times, ...parse_policies]
    }

  },

  created() {
    this.get_policies = get_policies
  },

  mounted() {
  },

  methods: {

    // Differenzia il contenuto testuale in base alla key
    get_policy_content(policy, key) {
      const obj = {
        type: key,
        content: policy,
      }
      if (key === "cots_and_extra_beds") {
        return {
          ...obj,
          currency: this.details.currency,
        }
      }
      return obj
    }
  },
}
</script>

<style lang="scss" scoped>

  .policies {
    @extend %section;
    @extend %section_margin;

    &__title {
      @extend %section__title;
    }

    &__wrap {
      background-color: $white;
      padding: 20px;
      border-radius: 10px;
    }
  }

</style>